document.addEventListener("DOMContentLoaded", function () {

  const images = document.querySelectorAll(".product__media img");

  images.forEach(img => {

    const container = img.parentElement;

    container.classList.add("zoom-container");

    const zoomBox = document.createElement("div");
    zoomBox.className = "zoom-result";

    container.appendChild(zoomBox);


    container.addEventListener("mousemove", function(e){

      let rect = img.getBoundingClientRect();

      let x = e.clientX - rect.left;
      let y = e.clientY - rect.top;


      zoomBox.style.display = "block";

      zoomBox.style.backgroundImage =
      `url(${img.src})`;


      zoomBox.style.backgroundPosition =
      `${x}px ${y}px`;

    });


    container.addEventListener("mouseleave", function(){

      zoomBox.style.display="none";

    });

  });

});